// extracted by mini-css-extract-plugin
module.exports = {"text-regular":"14px","text-large":"16px","font-family-light":"TreatwellSansWeb-Light","markdown":"Markdown-module--markdown--0f06a3"};